import { createContext } from 'react';

import { StatsTimeframe } from 'modules/stats/types';
import { IFetchPublicStatsParams } from 'modules/stats/actions/fetchPublicStats';

export const ChainsPublicStatsContext = createContext<IFetchPublicStatsParams>({
  timeframe: StatsTimeframe.Month,
});
